<template >
  <v-app>
    <div id="app" fluid :style="`background: linear-gradient(180deg, #262626 18.75%, #009E53 99.48%); width: ${$vuetify.breakpoint.width}; height: 100vh`">
      <router-view/>
    </div>
  </v-app>
</template>

<script>

export default  {
  mounted() {
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
